(() => {
  const main = document.querySelector('#MainContent');
  if (!main || !document.body.classList.contains('kales-cercana-theme')) return;

  const frames = [
    '.product-media',
    '.kales-collection-card__photo',
    '.kales-favorite__photo',
    '.kales-clientas__image-link',
  ].join(',');
  const pending = new WeakMap();
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

  function enhance(img) {
    if (!(img instanceof HTMLImageElement)) return;
    const frame = img.closest(frames);
    // Retire previous state, including classes copied by a gallery/quick-view clone.
    pending.get(img)?.();
    img.classList.remove('kales-photo-pending', 'kales-photo-reveal');
    frame?.classList.remove('kales-photo-loading-frame');
    if (!frame || !main.contains(frame) || img.fetchPriority === 'high' ||
        img.closest('dialog, zoom-dialog, .zoom-dialog') ||
        frame.querySelector('video, product-model, deferred-media')) return;

    // Cached, loaded and failed images remain visible without a placeholder flash.
    if (img.complete) return;

    const cleanup = () => {
      img.removeEventListener('load', loaded);
      img.removeEventListener('error', failed);
      img.classList.remove('kales-photo-pending');
      frame.classList.remove('kales-photo-loading-frame');
      pending.delete(img);
    };
    const loaded = () => {
      cleanup();
      if (img.naturalWidth && !reducedMotion.matches) {
        img.classList.add('kales-photo-reveal');
      }
    };
    const failed = () => cleanup();
    pending.set(img, cleanup);
    img.addEventListener('load', loaded, { once: true });
    img.addEventListener('error', failed, { once: true });
    frame.classList.add('kales-photo-loading-frame');
    img.classList.add('kales-photo-pending');
    // Covers completion between the first check and event subscription.
    if (img.complete) img.naturalWidth ? loaded() : failed();
  }

  function scan(root) {
    if (!(root instanceof Element)) return;
    if (root.matches('img')) enhance(root);
    root.querySelectorAll('img').forEach(enhance);
  }

  scan(main);
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes') enhance(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(main, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'srcset'],
  });
})();
